const EN = {
    title: 'Cobranzas',
    table: {
        title: 'Listado de cobranzas transaccionales',
        columns: {
            id: 'Nro. Operación',
            paymentDate: 'Operación fecha',
            code: 'GP Confirmación',
            informedDate: 'Fecha cobro',
            amount: 'Monto',
            barCode: 'Observación',
            document: 'INE',
            lastFour: 'Últimos 4',
            status: 'Estado'
        },
        info: {
            title: 'Información de código:',
            1: 'Identificación de Natura (3 digitos)',
            2: 'INE del cliente (8 digitos)',
            3: 'Periodo AAAAMM (6 digitos)',
            4: 'Identificacion del cliente (6 digitos)',
            5: 'Ultimos 4 (4 digitos)',
            6: 'Pago total (1 digito)',
            7: 'Importe, 9 enteros mas 2 decimales (11 digitos)',
            8: 'Fecha AAMMDD (6 digitos)'
        },
        status: {
            informed: 'Informado',
            1: 'Pendiente',
            2: 'Informado',
            3: 'Error'
        },
    }
};

export default EN;
